// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"113":"deb47daf","319":"be4c6de3"}[chunkId] + ".js";
};